import { Box } from '@mui/material';

function AccommodationsEmail(props) {
  return (
    <Box my={2} textAlign={'center'} {...props}>
      If you have any accessibility or accommodation requests, please contact us at
      <a style={{ marginLeft: '5px' }} href="mailto:accommodations@gojitsu.com">
        accommodations@gojitsu.com
      </a>
      .
    </Box>
  );
}

export default AccommodationsEmail;
